export const READ_PLAYGROUND_OUTPUT_TOOL_NAME = "read_playground_output";
